/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
// @ts-expect-error: Incorrect type
import DraggableObject from 'ember-drag-drop/components/draggable-object';
import { formatNumber, t } from 'ember-intl';
import { and, not } from 'ember-truth-helpers';
import type { Roomtype } from 'frontend-utils/models';
import type { RoomtypeMappingType } from 'frontend-utils/models/roomtype';
import { CURRENCY_MAPPING } from 'frontend-utils/utils/constants/currency-mapping-constants';
import SettingsCentralMappingRoomtypeMappingCellRoomtypeSelect from 'lumen/components/settings/central-mapping/roomtype-mapping/cell-roomtype-select';
import getNumberDifference from 'lumen/helpers/get-number-difference';
import getNumberSignClass from 'lumen/helpers/get-number-sign-class';
import { CHANNEL_ROOM_MAPPING_PRODUCTS } from 'lumen/utils/central-mapping-constants';
import getAverage from 'lumen/utils/numeric/get-average';

// @ts-expect-error: Incorrect type
function formatCurrency(currency): string {
  if (!currency) {
    return '';
  }

  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
  return CURRENCY_MAPPING[currency] ?? '';
}

interface AveragePriceInfo {
  avgRoomtypeCurrency: string;
  avgRoomtypePrice: number;
  nbOfRoomnames: number;
}

interface SettingsCentralMappingRoomtypeMappingCellRoomtypeSignature {
  Args: {
    canEdit: unknown;
    dragStartedForHotel: unknown;
    hotel: unknown;
    hotelinfo: unknown;
    overrideRoom: unknown;
    roomtype: unknown;
    sortedSelections: unknown;
  };
}

export default class SettingsCentralMappingRoomtypeMappingCellRoomtype extends Component<SettingsCentralMappingRoomtypeMappingCellRoomtypeSignature> {
  @service declare access: Services['access'];
  @service declare store: Services['store'];

  @tracked showTooltip = true;

  @computed('ownHotelRoomtype', 'ownHotelRoomtype.roomtypeMapping')
  get hasOwnHotelRoomtypeMappingData(): RoomtypeMappingType[] | null {
    return this.ownHotelRoomtype && this.ownHotelRoomtype.roomtypeMapping;
  }

  @computed(
    // eslint-disable-next-line ember/use-brace-expansion
    'args.hotel.hotelinfo.id',
    'args.hotelinfo.id',
    'this.args.hotel.hotelinfo.id',
    'this.args.hotelinfo.id',
  )
  get isOwnHotelRoomType(): boolean {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return this.args.hotel.hotelinfo.id === this.args.hotelinfo.id;
  }

  @computed(
    'args.roomtype.rid',
    'hasOwnHotelRoomtypeMappingData',
    'ownHotelRoomtype.roomtypeMapping.@each.roomtype_id',
    'this.args.roomtype.rid',
  )
  get ownHotelAvgPriceInfo(): AveragePriceInfo {
    if (this.hasOwnHotelRoomtypeMappingData) {
      // @ts-expect-error: Incorrect type
      const rooms = this.ownHotelRoomtype.roomtypeMapping.filter(
        // @ts-expect-error: Incorrect type
        (room) => room.roomtype_id === this.args.roomtype.rid,
      );

      return this.getAveragePriceInfo(rooms);
    }

    return {
      nbOfRoomnames: 0,
      avgRoomtypePrice: 0,
      avgRoomtypeCurrency: '',
    };
  }

  @computed('args.{hotel.id,hotelinfo.id,dataType,otaId}')
  get ownHotelRoomtype(): Roomtype | null {
    // @ts-expect-error: Incorrect type
    const baseId = `${this.args.hotel.id},${this.args.hotelinfo.id},${this.args.otaId}`;

    const ownHotelRoomtypeId =
      // @ts-expect-error: Incorrect type
      this.args.dataType === CHANNEL_ROOM_MAPPING_PRODUCTS.ALL_PRODUCTS
        ? baseId
        : // @ts-expect-error: Incorrect type
          `${baseId},${this.args.dataType}`;

    return this.store.peekRecord<Roomtype>('roomtype', ownHotelRoomtypeId);
  }

  @computed('args.roomtype.rid', 'roomtype.roomtypeMapping.@each.roomtype_id')
  get rooms(): RoomtypeMappingType[] {
    if (this.roomtype && this.roomtype.roomtypeMapping) {
      return this.roomtype.roomtypeMapping.filter(
        // @ts-expect-error: Incorrect type
        (room) => room.roomtype_id === this.args.roomtype.rid,
      );
    }

    return [];
  }

  @computed('args.{hotel.id,hotelinfo.id,dataType,otaId}')
  get roomtype(): Roomtype | null {
    // @ts-expect-error: Incorrect type
    const baseId = `${this.args.hotel.id},${this.args.hotelinfo.id},${this.args.otaId}`;
    const roomTypeId =
      // @ts-expect-error: Incorrect type
      this.args.dataType === CHANNEL_ROOM_MAPPING_PRODUCTS.ALL_PRODUCTS
        ? baseId
        : // @ts-expect-error: Incorrect type
          `${baseId},${this.args.dataType}`;

    return this.store.peekRecord<Roomtype>('roomtype', roomTypeId);
  }

  @computed('rooms')
  get roomtypeAvgPriceInfo(): AveragePriceInfo {
    return this.getAveragePriceInfo(this.rooms);
  }

  // @ts-expect-error: Incorrect type
  getAveragePriceInfo(rooms): AveragePriceInfo {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    const averagePrices = rooms.map((room) => room.avg_price);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const nbOfRoomnames = averagePrices.length;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const avgRoomtypePrice = getAverage(averagePrices);
    let avgRoomtypeCurrency = '';

    if (nbOfRoomnames) {
      // @ts-expect-error: Incorrect type
      avgRoomtypeCurrency = this.rooms[0].avg_currency;
    }

    return {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      nbOfRoomnames,
      avgRoomtypePrice,
      avgRoomtypeCurrency,
    };
  }

  @action
  dragEnd(): void {
    this.showTooltip = true;
  }

  @action
  dragStart(): void {
    this.showTooltip = false;
    // @ts-expect-error: Incorrect type
    this.args.dragStartedForHotel(
      // @ts-expect-error: Incorrect type
      this.args.hotelinfo.id,
      // @ts-expect-error: Incorrect type
      this.args.roomtype.rid,
    );
  }

  @action
  // @ts-expect-error: Incorrect type
  selectRoomtype(newRoom, oldRoom): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const newRoomtypeId = newRoom.rid;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const newRoomtypeName = newRoom.name;
    // @ts-expect-error: Incorrect type
    this.args.overrideRoom(
      // @ts-expect-error: Incorrect type
      this.args.hotelinfo.id,
      oldRoom,
      newRoomtypeId,
      newRoomtypeName,
    );
  }

  <template>
    {{! @glint-nocheck }}
    <div class="droppabletd {{this.hotel.competitor.id}} {{this.roomtype.rid}}">
      <div
        class="draggable
          {{unless this.access.hasRoomtypeMappingEditRights 'read-only'}}"
      >
        {{#each this.rooms as |room|}}
          <DraggableObject
            @content={{room}}
            @dragEndAction={{this.dragEnd}}
            @dragStartAction={{this.dragStart}}
            @isDraggable={{this.access.hasRoomtypeMappingEditRights}}
            class="flex flex-col"
          >
            {{#if @canEdit}}
              <SettingsCentralMappingRoomtypeMappingCellRoomtypeSelect
                @onSelectRoom={{this.selectRoomtype}}
                @room={{room}}
                @sortedSelections={{@sortedSelections}}
              />
            {{else}}
              <p
                class="text-300--regular first-letter-uppercase"
              >{{room.name}}</p>
            {{/if}}
            {{#if this.showTooltip}}
              <EmberTooltip
                @tooltipClass="default-tooltip default-table-tooltip roomtype-mapping-roomname-tooltip"
              >
                <table class="default-table">
                  <thead>
                    <tr>
                      <th
                        class="default-table__compact-header roomtype-mapping-roomname-tooltip__room-name truncate"
                        colspan="2"
                      >{{room.name}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="avg-price">
                      <td class="avg-price__description">{{t
                          "rates.roomtype.avg_price_this_room"
                        }}</td>
                      <td class="avg-price__value">
                        {{formatCurrency room.avg_currency}}
                        {{formatNumber
                          room.avg_price
                          maximumFractionDigits=0
                          minimumFractionDigits=0
                        }}
                      </td>
                    </tr>
                    {{#if
                      (and
                        this.hasOwnHotelRoomtypeMappingData
                        (not this.isOwnHotelRoomType)
                      )
                    }}
                      <tr class="avg-price">
                        <td class="avg-price__description">{{t
                            "rates.roomtype.avg_price_for_own_roomtype"
                            roomtype=@roomtype.proper_name
                          }}</td>
                        <td class="avg-price__value">
                          {{#if this.ownHotelAvgPriceInfo.nbOfRoomnames}}
                            {{formatCurrency
                              this.ownHotelAvgPriceInfo.avgRoomtypeCurrency
                            }}
                            {{formatNumber
                              this.ownHotelAvgPriceInfo.avgRoomtypePrice
                              maximumFractionDigits=0
                              minimumFractionDigits=0
                            }}
                            <span
                              class={{getNumberSignClass
                                (getNumberDifference
                                  this.ownHotelAvgPriceInfo.avgRoomtypePrice
                                  room.avg_price
                                )
                              }}
                            >
                              {{getNumberDifference
                                this.ownHotelAvgPriceInfo.avgRoomtypePrice
                                room.avg_price
                              }}
                            </span>
                          {{else}}
                            {{t "rates.roomtype.unavailable"}}
                          {{/if}}
                        </td>
                      </tr>
                    {{/if}}
                  </tbody>
                </table>
              </EmberTooltip>
            {{/if}}
          </DraggableObject>
        {{/each}}
      </div>
    </div>

    <div class="roomtype-container-avg-price-block">
      {{#if this.roomtypeAvgPriceInfo.nbOfRoomnames}}
        <p class="text-300--regular">{{t "general.avg_price"}}</p>
        <p class="text-300--regular">
          <span class="emphasis emphasis--primary">
            {{formatCurrency this.roomtypeAvgPriceInfo.avgRoomtypeCurrency}}
            {{formatNumber
              this.roomtypeAvgPriceInfo.avgRoomtypePrice
              maximumFractionDigits=0
              minimumFractionDigits=0
            }}
          </span>
        </p>
      {{/if}}
    </div>
  </template>
}
